// extracted by mini-css-extract-plugin
export default {"buttonLink":"ButtonLink_buttonLink__A84pR","title":"ButtonLink_title__XRaNY","icon":"ButtonLink_icon__2gaSm"};